import * as React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

/**
 * Drop-in replacement for emoji-rich native select that triggers
 * 'span inside option' hydration warning. Uses Radix under the hood.
 * Usage: <EmojiSelect value={v} onChange={setV} options={[{id,label}]} testid="x" />
 */
export const EmojiSelect = ({ value, onChange, options, placeholder = "Seleccionar", className = "", testid, "data-testid": dataTestid }) => {
  const tid = testid || dataTestid;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`aura-input h-10 ${className}`} data-testid={tid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt.id} value={opt.id}>{opt.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default EmojiSelect;
